import usingServiceAdvantage from './usingJapanRamenAdvantage';
import frequentlyAskedQuestions from './japanese-ramen-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Sushi & Ramen Restaurant POS',
      description: `All-in-one platform to harmonize the front-of-house, kitchen, and guest experience for Japanese restaurants.`,
    },
    zh: {
      title: '寿司&拉面店',
      description: '使用Chowbus POS统一管理前厅和后厨',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended Products for Sushi & Ramen Restaurants',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
